// extracted by mini-css-extract-plugin
export default {"viewBtn":"ReviewList_viewBtn__NzLAy","itemThumb":"ReviewList_itemThumb__bHJYv"};